import { http } from './http_service';

//Get list of maturing leas
export function listPage(obj){
    let params = {
        page:obj.page,
        recordsPerPage:obj.recordsPerPage,
        q:obj.q,
        fromDate:obj.fromDate,
        toDate:obj.toDate,
        selectedStatus:obj.selectedStatus,
        sort_direction:obj.sort_direction,
        sort_field:obj.sort_field
    }
    return http().get(`/maturing-leas/list-page`, {
        params:params
    });
}

/**
 * Add maturing leas note
 * @param integer quoteId
 * @param object data
 * @returns
 */
export function addNote(quoteId, data){
    return http().post(`/maturing-leas/add-note/${quoteId}`, data)
}


//For Export Maturing Leas List
export function createListExport(obj){
    let params = {
        page:obj.page,
        recordsPerPage:obj.recordsPerPage,
        q:obj.q,
        selectedStatus:obj.selectedStatus,
        fromDate:obj.fromDate,
        toDate:obj.toDate,
        sort_direction:obj.sort_direction,
        sort_field:obj.sort_field
    }
    return http().get(`/maturing-leas/export/create-list`, {
        params:params
    });
}

// Delete Export MaturingLeas List in temp folder
export function deleteListExport(data){
    return http().put(`/maturing-leas/export/delete-list`, data)
}

/**
 * @param integer oldQuoteId
 * @param {*} data
 * @returns void
 */
export function copyQuote(data){
    return http().post(`/maturing-leas/copy/quote`, data)
}

/**
 * @param {*} data
 * @returns void
 */
export function sendAssignedQuoteNotification(data){
  return http().post(`/maturing-leas/send-assigned-quote-notification`, data)
}

